import { theme } from '@xbto/design-system';
import { ColorType, } from 'lightweight-charts';
import { getXAxisLabel } from './utils';
export const fundGraphChartHeight = 300;
export const chartOptions = {
    layout: {
        background: {
            type: ColorType.Solid,
            color: theme.color.background.white,
        },
        textColor: theme.color.text.secondary,
        fontSize: parseInt(theme.fontsize['2xs'], 10),
        fontFamily: "'Inter', sans-serif",
        attributionLogo: false,
    },
    height: fundGraphChartHeight,
    handleScale: false,
    handleScroll: false,
    autoSize: true,
    grid: {
        vertLines: {
            visible: false,
        },
        horzLines: {
            visible: false,
        },
    },
    crosshair: {
        vertLine: {
            visible: true,
            labelVisible: false,
            style: 2,
            color: theme.color.border.secondary,
        },
        horzLine: {
            visible: true,
            labelVisible: false,
            style: 2,
            color: theme.color.border.secondary,
        },
    },
    timeScale: {
        fixLeftEdge: false,
        fixRightEdge: false,
        timeVisible: true,
        borderColor: 'transparent',
        allowBoldLabels: false,
        rightOffset: 0,
        tickMarkFormatter: time => getXAxisLabel(time),
    },
    rightPriceScale: {
        visible: true,
        borderColor: 'transparent',
        textColor: theme.color.text.secondary,
        entireTextOnly: true,
        ticksVisible: false,
        autoScale: true,
    },
    leftPriceScale: {
        visible: true,
        borderColor: 'transparent',
        textColor: theme.color.text.secondary,
        entireTextOnly: true,
        ticksVisible: false,
        autoScale: true,
    },
    localization: {
        locale: 'en-US',
    },
};
export const lineSeriesOptions = {
    lineWidth: 2,
    pointMarkersVisible: false,
    crosshairMarkerVisible: false,
    priceLineVisible: false,
    lastValueVisible: false,
};
export const markerSeriesOptions = {
    lineWidth: 1,
    priceLineVisible: false,
    lastValueVisible: false,
};
